import type { PropsWithChildren } from "react";

import { Disclosure, DisclosureHeader, DisclosurePanel } from "@stacklet/ui";

interface Props extends PropsWithChildren {
  /** The disclosure's label, e.g. "Using a Personal API Key (Optional)". */
  title: string;
}

/** A secondary route through a client's instructions, folded away by default. */
export function McpDisclosure({ title, children }: Props) {
  return (
    <Disclosure>
      <DisclosureHeader
        className="w-fit gap-x-xs text-title-small"
        position="leading"
      >
        {title}
      </DisclosureHeader>

      <DisclosurePanel>
        <div className="flex flex-col gap-md pt-xs">{children}</div>
      </DisclosurePanel>
    </Disclosure>
  );
}
